import { Breadcrumb } from '@nackle/paper';
import { ChevronRight } from '@nackle/icons';
import { Link } from '@reach/router';
import { ROUTE_MAP } from 'components/app/routeMap';
import { ComponentRoute, RouteSpec } from 'components/app/routing/types';
import flatMap from 'lodash/flatMap';
import sortBy from 'lodash/sortBy';
import React, { Component } from 'react';
import './nav.less';

interface Props {
    path: string;
}

interface MatchTuple {
    pathPattern: string;
    matchedSegment: string;
    restPath: string;
    score: string | number;
}

class Nav extends Component<Props> {

    getBreadcrumbs = (path: string, routes: RouteSpec, parentPath = ''): any[] => {
        // Annoyingly, Reach Router does not expose its algorithm for resolving routes.
        // So we have to reproduce what it does.

        const matches: MatchTuple[] = flatMap(Object.keys(routes), (pathPattern: string): MatchTuple[] => {
            // Filter out redirects
            if ('redirectTo' in routes[pathPattern]) return [];
        
            const match = path.match('^(' + pathPattern.replace(/:\w+/, '[^/]+') + ')(.*)');
            if (!match) return [];

            const matchedSegment = match[1];
            const restPath = match[match.length - 1];

            // When multiple routes match, the route with the highest score is determined to be the
            // most likely. Reach router uses a similar mechanism, but theirs is a lot more sophisticated.
            const score = -pathPattern.length;

            return [{
                pathPattern,
                matchedSegment: matchedSegment,
                restPath,
                score,
            }];
        });

        if (!matches.length) {
            return [];
        }

        const { pathPattern, matchedSegment, restPath } = sortBy(matches, 'score')[0];
        const { children, label } = routes[pathPattern] as ComponentRoute;

        const absolutePath = parentPath + matchedSegment;
        let breadcrumbs = (children) ? this.getBreadcrumbs(restPath, children, absolutePath) : [];
        if (label) {
            const breadcrumb: any = { href: absolutePath, icon: <ChevronRight/>, text: label };
            breadcrumbs = [breadcrumb, ...breadcrumbs];
        }
        return breadcrumbs;
    };

    renderBreadcrumb = (breadcrumbs) => {
        return (
            <Breadcrumb>
                {breadcrumbs.map(breadcrumb => (
                    (breadcrumb.href && breadcrumb.href !== this.props.path) ?
                        <Breadcrumb.Item key={breadcrumb.key}>
                            <Link key={breadcrumb.key} to={breadcrumb.href} >
                                {breadcrumb.text}
                            </Link>
                        </Breadcrumb.Item> :
                        <Breadcrumb.Item key={breadcrumb.key}>
                            {breadcrumb.text}
                        </Breadcrumb.Item>
                ))}
            </Breadcrumb>
        );
    };

    render() {
        const breadcrumbs = this.getBreadcrumbs(this.props.path, ROUTE_MAP);
        return (
            <div className="nav-wrapper">
                {this.renderBreadcrumb(breadcrumbs)}
            </div>
        );
    }
}

export default Nav;
